import styled from 'foundations-theming-specialty/utils';
import { NPSThankYouSVG } from './NPSThankYouSVG';
import { useTranslation } from '../../hooks/useNavConfig';
import { Text } from 'breadcrumbs-ui/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledColOne = styled.div.withConfig({
  displayName: "FeedbackCompletionStep__StyledColOne",
  componentId: "w7jlh2-0"
})(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  width: '100px',
  marginBottom: theme.space['400']
}));
const StyledColTwo = styled.div.withConfig({
  displayName: "FeedbackCompletionStep__StyledColTwo",
  componentId: "w7jlh2-1"
})(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.space['400'],
  padding: `${theme.space[800]} 0`
}));
const StyledCloseButton = styled.button.withConfig({
  displayName: "FeedbackCompletionStep__StyledCloseButton",
  componentId: "w7jlh2-2"
})(({
  theme
}) => Object.assign({
  display: 'flex',
  color: theme.color['fill-info-default']
}, theme.typography['heading-50'], {
  background: 'transparent',
  border: '0',
  textAlign: 'center',
  margin: '0 auto',
  '&:hover': {
    textDecoration: 'underline'
  }
}));
const Flex = styled.div.withConfig({
  displayName: "FeedbackCompletionStep__Flex",
  componentId: "w7jlh2-3"
})(["display:flex;"]);
export const FeedbackCompletionStep = ({
  completeSurvey,
  hideIllustration
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs(Flex, {
    children: [!hideIllustration && /*#__PURE__*/_jsx(StyledColOne, {
      children: /*#__PURE__*/_jsx(NPSThankYouSVG, {})
    }), /*#__PURE__*/_jsxs(StyledColTwo, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h5",
        typography: "heading-100",
        textAlign: "center",
        children: t('nav.feedbackModal.completion.header')
      }), /*#__PURE__*/_jsx(Text, {
        as: "p",
        typography: "body-100",
        textAlign: "center",
        children: t('nav.feedbackModal.completion.body2')
      }), /*#__PURE__*/_jsx(StyledCloseButton, {
        onClick: () => void completeSurvey(),
        children: t('nav.feedbackModal.close')
      })]
    })]
  });
};